import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';

export const paineisAnaliticosVisualizacoesGuard: CanActivateFn = () => {
    if (environment.featureFlags.enableAnalyticalVisualizations) return true;

    return inject(Router).createUrlTree(['/paineis-analiticos/acesso']);
};
